import {
  AttendeesStatus,
  AttendeeType,
  PaymentMethod,
  StatusType,
} from "../../Enums/RegistrationEnum";
import IGeneralFields from "./IGeneralFileds";
import type { IJurisdiction } from "../../utils/jurisdiction/IJurisdiction";

export type MainEventGuestHistoryStatus = "Attending" | "Deleted";

export interface IMainEventGuestHistoryEntry {
  id: string;
  guest: string;
  registeredDate: number;
  registeredBy: string;
  status: MainEventGuestHistoryStatus;
  deletedDate?: number;
  deletedBy?: string;
}

export type SpecialEventGuestHistoryStatus = "Attending" | "Deleted";

export interface ISpecialEventGuestHistoryEntry {
  id: string;
  programId: string;
  programTitle: string;
  guest: string;
  registeredDate: number;
  registeredBy: string;
  status: SpecialEventGuestHistoryStatus;
  deletedDate?: number;
  deletedBy?: string;
}

export interface IAmountPaidHistoryEntry {
  id: string;
  amount: number;
  note?: string;
  savedBy: string;
  savedById?: string | null;
  paymentMethod?: PaymentMethod;
  date: number;
}

export interface IRegistrationStatusHistoryEntry {
  fromStatus: string;
  toStatus: string;
  changedBy: string;
  changedById?: string | null;
  date: number;
}

/** Main-event guest on a registration (max 2). */
export interface IRegistrationGuest {
  id: string;
  name: string;
  specialRequest?: string;
  /** Unix seconds. Set once when the guest is created. */
  registrationDate: number;
  /** Unix seconds. Updated when the guest is edited. Falls back to `registrationDate` for older records. */
  modificationDate?: number;
}

export const MAX_REGISTRATION_GUESTS = 2;

export interface IRegistration extends IGeneralFields {
  eventId: string;
  eventName?: string;
  eventDate?: number;
  eventType?: "inPerson" | "virtual" | "hybrid";
  eventSetupType?: string;
  personId: string;
  status?: AttendeesStatus;
  attendeeType: AttendeeType;
  cancelRegistrationDate?: number;
  badgeName: string;
  /** @deprecated Prefer `guests`. Kept for legacy Cosmos docs. */
  guestName?: string;
  /** @deprecated Prefer `guests`. Kept for legacy Cosmos docs. */
  guestName2?: string;
  guests?: IRegistrationGuest[];
  specialRequests?: string;
  registrationNotes?: string;
  paymentMethod?: PaymentMethod;
  paymentStatus: StatusType;
  registrationDate: number;
  firmId?: string;
  mainOffice?: string;
  mainOfficeName?: string;
  additionalOffices?: string[];
  prepaid?: boolean;
  isHostFirm?: boolean;
  countryName?: string;
  firmName?: string;
  personLastName?: string;
  personName?: string;
  personEmail?: string;
  personTitle?: string;
  firmJurisdiction?: IJurisdiction | string;
  officeJurisdiction?: IJurisdiction | string;
  firmRegion?: string;
  amountPaid?: number;
  totalAmount?: number;
  additionalFee?: number;
  note?: string;
  guestNumber?: number;
  shortId?: string;
  industry?: string;
  selectedSpecialEventIds?: string[];
  /** Rich guests per special-event program (max 2). Prefer over name-only map. */
  specialEventGuests?: Record<string, IRegistrationGuest[]>;
  /** @deprecated Prefer `specialEventGuests`. Kept for fees/emails/legacy docs. */
  specialEventGuestNames?: Record<string, string | string[]>;
  /** @deprecated Prefer AuditLog. Kept for legacy Cosmos docs. */
  mainEventGuestHistory?: IMainEventGuestHistoryEntry[];
  /** @deprecated Prefer AuditLog. Kept for legacy Cosmos docs. */
  specialEventGuestHistory?: ISpecialEventGuestHistoryEntry[];
  /** @deprecated Prefer AuditLog. Kept for legacy Cosmos docs. */
  amountPaidHistory?: IAmountPaidHistoryEntry[];
  /** @deprecated Prefer AuditLog. Kept for legacy Cosmos docs. */
  registrationStatusHistory?: IRegistrationStatusHistoryEntry[];
  createdFrom?: "member" | "staff";
}
